/* eslint-disable @typescript-eslint/no-explicit-any */
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Spin } from "antd";

import { DateField } from "../../../../atoms/FormFields";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import dayjs from "dayjs";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  loading: boolean;
  btnApi: () => void;
  selectedDate: string; // Optional prop for selected date
}

const MoveCrewScheduleBy = (props: PropsType) => {
  const { onClose, loading, btnApi, selectedDate } = props;

  const onCloseHandler = () => {
    onClose();
  };

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = (val: any) => {
    console.log(val);
  };

  useEffect(() => {
    if (selectedDate) {
      setValue("shift_from", dayjs(selectedDate));
    }
  }, [selectedDate, setValue]);

  const shiftTo = watch("shift_to");
  const difference = dayjs(shiftTo).diff(dayjs(selectedDate), "day");

  console.log("difference", selectedDate, shiftTo);

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper scheduleWrapper">
        <div className="modal_header">
          <div className="title">
            <h3> Shift crew's schedule </h3>
            <p style={{ color: "#151718" }}>
              All scheduled days starting from the <b>Shift from</b> date will
              be moved to start on the <b>Shift to</b> date.
            </p>
          </div>
        </div>
        <Form
          layout="vertical"
          onFinish={handleSubmit(onSubmit)}
          onKeyDown={(e) => {
            if (e.key === "Enter") e.preventDefault();
          }}
        >
          <div className="modal_content">
            <Row gutter={16}>
              <Col span={12}>
                <DateField
                  fieldName="shift_from"
                  label="Shift from"
                  control={control}
                  tooltipTitle="Shift from"
                  isRequired
                  rules={{
                    required: "Shift from is required.",
                  }}
                  validate={errors.shift_from && "error"}
                  validMessage={errors.shift_from && errors.shift_from.message}
                  iProps={{ disabled: true }}
                />
              </Col>
              <Col span={12}>
                <DateField
                  fieldName="shift_to"
                  label="Shift to"
                  control={control}
                  tooltipTitle="Shift to"
                  isRequired
                  rules={{
                    required: "Shift to is required.",
                  }}
                  validate={errors.shift_to && "error"}
                  validMessage={errors.shift_to && errors.shift_to.message}
                  // iProps={{ disabled: }}
                />
              </Col>
              {difference > 0 && (
                <Col span={24}>
                  <p
                    style={{
                      color: "#6C7478",
                      fontSize: "12px",
                      marginTop: "-8px",
                    }}
                  >
                    All visits from {dayjs(selectedDate).format("MMM D")} will
                    move{" "}
                    <span style={{ color: "#6454F4", fontWeight: "600" }}>
                      {difference + 1} working days later
                    </span>
                    . Days off excluded.
                  </p>
                </Col>
              )}
            </Row>
          </div>
        </Form>

        <div className="modal_footer">
          <Button
            htmlType="button"
            className="outlined-btn"
            type="default"
            size="large"
            onClick={onCloseHandler}
          >
            Cancel
          </Button>

          <Button
            htmlType="button"
            className="mint-btn"
            type="primary"
            size="large"
            onClick={btnApi}
            loading={loading}
          >
            Shift schedule
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default MoveCrewScheduleBy;
